<template>
  <div class="custom-form-control" @click.stop>
    <transition name="slide-right">
      <div v-if="isViewCtrl" class="custom-form-control-content">
        <el-form
          :model="formData.attribute"
          :rules="rules"
          ref="form"
          label-width="100px"
          class="demo-form"
          label-position="top"
          v-if="formData.type"
        >
          <h3>
            <span>{{ title }}</span>
          </h3>
          <component :is="formCom.get(formData.type)" :form="formData.attribute"> </component>
        </el-form>
      </div>
    </transition>
  </div>
</template>

<script>
import { formCom, control } from '../enum'
import { rules } from '../rule'
console.log(control)
export default {
  props: {
    formData: {
      default: ''
    },
    isViewCtrl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formCom
    }
  },
  computed: {
    rules: vm => {
      const form = vm.formData.attribute
      const result = {}
      if (!form) return result
      const keys = Object.keys(form)
      keys.forEach(item => {
        if (rules[item]) result[item] = rules[item]
      })
      return result
    },
    // 组件名称
    title: vm => {
      const type = vm.formData.type
      let title = ''
      control.forEach(item => {
        if (title) return false
        const result = item.list.filter(el => el.type === type)
        if (result && result[0]) title = result[0].name
      })
      return vm.$t(title)
    }
  }
}
</script>
